export const Styles = {
  sidebar: {
    heading: 'text-xs font-semibold leading-6 text-gray-600',
  },
  heading: {
    small: 'font-bold text-lg',
    large: 'font-bold text-2xl text-center py-2',
    subSmall: 'font-semibold text-sm text-gray-600',
  },
  block: {
    code: 'w-full h-full overflow-auto font-mono text-sm bg-gray-100 text-gray-700 p-2 rounded-sm',
  },
  input: {
    focus:
      'focus:outline-hidden focus:ring-3 focus:ring-offset-2 focus:ring-blue-500 focus:ring-opacity-90',
  },
  icon: {
    bordered:
      'flex h-6 w-8 shrink-0 items-center justify-center rounded-sm border border-gray-400 bg-white text-[0.625rem] font-medium text-gray-600 group-hover:border-blue-600 group-hover:text-blue-600',
  },
  prose: 'typography',
}
